import { Button } from '@mui/material'
import React from 'react'
import { ApplicationTypes } from 'sunlife-domain'

import { configuratorInterface } from '../../systems/configurator-interface'

export const AddToCartButton: React.FC = () => {
  const { storeSystem, navigationSystem } = configuratorInterface.useDomain()
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        storeSystem.stageAndCommit([
          navigationSystem.getNavigationUpdate(ApplicationTypes.NavigationState.FinalizeCart),
        ])
      }}
    >
      Add to cart
    </Button>
  )
}
